import React from 'react';
import c from 'classnames';
import { Menu } from '@uncinc/react-drupal-core';
import { useDispatch } from 'react-redux';
import { CoreLink } from '../../../components';

import { hideNavMenu } from '../../../actions/UI';
import { MENU_OTHER, MENU_OTHER_KP } from '../../../config/constants';

import './style.scss';

const NavigationSecondaryMenu = ({ domainKp }) => {
  const dispatch = useDispatch();

  return (
    <div className="NavigationSecondaryMenu">
      <Menu id={domainKp ? MENU_OTHER_KP : MENU_OTHER}>
        {(items) => {
          return (
            <div className="NavigationSecondaryMenu__items">
              {items.map((item) => {
                const attrs = item.getIn(['link', 'options', 'attributes'], new Map());
                const href = item.getIn(['link', 'url'], '');
                const title = item.getIn(['link', 'title'], 'Untitled');
                const classes = item.getIn(['link', 'options', 'attributes', 'class'], []);

                const itemClass = c('GenericNavigationMainMenu__itemWrapper', ...classes);

                return (
                  <li key={`menu--main--menu-item-${title}:${href}`} className="menu--main--menu-item">
                    <div className={itemClass}>
                      <CoreLink
                        to={href}
                        target={attrs.get('target')}
                        onClick={() => { dispatch(hideNavMenu()); }}
                      >
                        {title}
                      </CoreLink>
                    </div>
                  </li>
                );

              })}
            </div>
          );
        }}
      </Menu>
    </div>
  );
};

export default NavigationSecondaryMenu;
